import { useIsPilotRestricted } from '@/shared/hooks/use-active-pilot-program';
import { useCareHasStarted } from '@/shared/hooks/use-care-has-started';

/**
 * Whether the policy half of guided planning applies at all.
 *
 * Keyed off the `quote-apply` capability rather than a named pilot flag. The rule is "this
 * advisor cannot shop policies", and every program that withholds Quote & Apply means it, so
 * hardcoding one flag left later programs walking through preference and quote steps that could
 * only ever fail at the API.
 */
export function useSkipPolicySteps(): boolean {
  const isQuoteApplyRestricted = useIsPilotRestricted('quote-apply');
  const careHasStarted = useCareHasStarted();

  return isQuoteApplyRestricted || careHasStarted;
}
